export class AppointmentRequest {
  id: number;
  matter_id: number;
  location_id: number;
  status: string;
  checked_out_by: number;
  checked_out_on: string;
  length: number;
  how_soon: string;
  event_type_id: number;
  pre_notes: string;
  notes: string;
  event_id: number;
  created_at: string;
  updated_at: string;
  created_by: number;
  updated_by: number;
  matter_history_id: number;
  intranet_id: number;
  phone_number_id: number;
  mobile_request: boolean;
  appointment_request_type_id: number;
}
